import React from "react";

import { SectionTitle } from "./SectionTitle";
import { Description } from "./Description";

interface SectionHeaderProps {
  title: string;
  description: string;
  action: string;
  onActionClick?: () => void;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  description,
  action,
  onActionClick,
}) => {
  return (
    <>
      <div className="mb-2 flex items-center justify-between"></div>
      <SectionTitle>{title}</SectionTitle>
      <Description>{description}</Description>
    </>
  );
};
